import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { Country } from "../types/country";
import { RequestsService } from "../_shared/services/requests.service";
import { StateService } from "./state.service";

const initialState = {
  countrie: [],
};

@Injectable({
  providedIn: "root",
})
export class CountryStateService extends StateService<any> {
  countries$: Observable<Country[]> = this.select((state) => {
    return state.countries;
  });
  constructor(private requestService: RequestsService) {
    super(initialState);
  }

  public getCountries() {
    this.setState({ isLoading: true });
    return this.requestService.dash_get("country", null, true).pipe(
      map((response) => {
        return response.data;
      }),
      tap(
        (countries: Country[]) => {
          this.setState({ countries, isLoading: false });
        },
        (err) => {
          this.setState({ isLoading: false });
        }
      )
    );
  }

  public getDistricts(countryId: string) {
    return this.countries$.pipe(
      map((countries) => {
        const country = countries.find((country) => country.id === countryId)
        if (country) {
          return country.districts || [];
        }
        return []
      }))
  }
}
